import React from 'react';
import NotFoundIcon from 'icons/notfound.svg';
import { Page } from 'containers';
import { SimplePlaceHolder } from 'components/SimplePlaceholder';
import styles from './NotFound.scss';

const NotFound = () => {
  return (
    <Page className={styles.container} title="" showBreadcrumbs={false}>
      <SimplePlaceHolder
        title="Page Not Found"
        content="Sorry, that page doesn't seem to exist!"
        image={NotFoundIcon}
        alt="not found"
      />
    </Page>
  );
};

export default NotFound;
